import { render, staticRenderFns } from "./expertMembers.vue?vue&type=template&id=1c5e7112&scoped=true"
import script from "./expertMembers.vue?vue&type=script&lang=js"
export * from "./expertMembers.vue?vue&type=script&lang=js"
import style0 from "./expertMembers.vue?vue&type=style&index=0&id=1c5e7112&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5e7112",
  null
  
)

export default component.exports